import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import InputText from '../Inputs/InputText'
import Datepicker from '../Inputs/Datepicker'
import { dateToDB } from '../../utils/utils'

const AdvancedSubscribersForm: React.FC<IAdvancedSubscribersForm> = ({
  onSubmit,
  onCloseAdvancedForm,
}) => {
  const form = useForm()
  const [expirationDateFrom, setExpirationDateFrom] = useState<string>('')
  const [expirationDateTo, setExpirationDateTo] = useState<string>('')

  const handleSubmit = (values: any) => {
    const params: any = {}

    if (values.search) {
      params.search = values.search
    }

    if (expirationDateFrom) {
      params.expirationDate_from = dateToDB(expirationDateFrom)
    }

    if (expirationDateTo) {
      params.expirationDate_to = dateToDB(expirationDateTo)
    }

    onSubmit(params)
  }

  return (
    <Form form={form} onSubmit={handleSubmit} classes="gap-x-2 p-2">
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere">
        Búsqueda avanzada
      </label>

      <FormItem name="search" classes="col-span-12 row-start-2">
        <InputText small label="Buscar por nombre o documento" maxLength={80} />
      </FormItem>

      <FormItem
        name="expirationDate_from"
        classes="lg:col-span-6 col-span-12 row-start-3"
      >
        <Datepicker
          label="Fecha fin suscripción (desde)"
          size="small"
          onChangeDate={(date: string) => setExpirationDateFrom(date)}
        />
      </FormItem>

      <FormItem
        name="expirationDate_to"
        classes="lg:col-span-6 col-span-12 row-start-3"
      >
        <Datepicker
          label="Fecha fin suscripción (hasta)"
          size="small"
          onChangeDate={(date: string) => setExpirationDateTo(date)}
        />
      </FormItem>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCloseAdvancedForm()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedSubscribersForm {
  onSubmit: Function
  onCloseAdvancedForm: Function
}

export default AdvancedSubscribersForm
